import React from "react";
import { Link } from "gatsby";
import './PostSidebar.css'
import _ from 'lodash';
import { PageContext } from '../../templates/blog/post';
export interface PostCardProps {
  post: PageContext;
  large?: boolean;
}
export const Category: React.FC = ({post}) => {
  return (
    <>
      {post.frontmatter.tags && (
        <li><Link to={`/tags/${_.kebabCase(post.frontmatter.tags[0])}/`}>
          {post.frontmatter.tags[0]}
        </Link> </li>)}
    </>
  );
};